import script from "./TinyButton.vue?vue&type=script&setup=true&lang=ts"
export * from "./TinyButton.vue?vue&type=script&setup=true&lang=ts"

import "./TinyButton.vue?vue&type=style&index=0&id=1994bed6&lang=scss"

const __exports__ = script;

export default __exports__